import styled from '@emotion/styled';
import { COLOR } from '@ordermentum/ui-constants';
import { getColor, getSize } from './utilities';

type IconWrapperProps = {
  size?: string;
  color?: string;
};

const getWrapperSize = ({ size }: IconWrapperProps): string => getSize(size);

export const IconWrapper = styled('div')<IconWrapperProps>`
  height: ${getWrapperSize};
  pointer-events: none;
  width: ${getWrapperSize};

  * {
    pointer-events: none;
  }

  .svg-fill {
    fill: ${p => getColor(p.color)};
  }

  .shadow {
    filter: drop-shadow(0 1px 1px ${COLOR.GRAY_800});
  }

  .svg-stroke {
    stroke: ${props => getColor(props.color)};
  }
`;

export const LegacyIcon = styled('span')<{ size: string }>`
  display: flex;
  font-size: ${getWrapperSize};
`;
